/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { GetOrganisationCategoriesParams, OrganisationCategoriesResponse } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class CategoryController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags category-controller
   * @name GetOrganisationCategories
   * @request GET:/api/v1/categories
   */
  getOrganisationCategories = (
    query: GetOrganisationCategoriesParams,
    params: RequestParams = {},
  ) =>
    this.http.request<OrganisationCategoriesResponse, any>({
      path: `/v1/categories`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getOrganisationCategoriesPath = '/v1/categories'
  static getOrganisationCategoriesMethod = 'GET'
}
